module.exports = __webpack_public_path__ + "img/roles.70497b2b.png";